import Index from 'src/pages/Boxes/Index.vue'
import Create from 'src/pages/Boxes/Create.vue'
import Edit from 'src/pages/Boxes/Edit.vue'

const auth = { requiresAuth: true }
const notUser = { requiresNotUser: true }

export default [
  {
    path: '/boxes',
    name: 'Boxen',
    component: Index,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/boxes/create',
    name: 'Box Erstellen',
    component: Create,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/boxes/:id/edit',
    name: 'Box Bearbeiten',
    component: Edit,
    meta: { ...auth, ...notUser }
  }
]
